export function Card({ children, className = '', padding = true, ...props }) {
  return (
    <div
      className={`rounded-xl border border-slate-200 bg-white shadow-[0_8px_24px_rgba(15,23,42,0.05)] ${padding ? 'p-3 sm:p-4' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}

export function CardHeader({ title, subtitle, action }) {
  return (
    <div className="mb-2 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
      <div>
        {title && (
          <div className="text-lg font-extrabold text-slate-900">{title}</div>
        )}
        {subtitle && (
          <div className="mt-0.5 text-sm font-medium text-slate-500">{subtitle}</div>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  )
}
